import { render, staticRenderFns } from "./LoadingScreen.vue?vue&type=template&id=ad4fb30a&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"
import style0 from "./LoadingScreen.vue?vue&type=style&index=0&id=ad4fb30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4fb30a",
  null
  
)

export default component.exports